/**
 * An installed capability card's priority, read-only (optum-agent Feature 87,
 * D10): its level, marked when it is the default, and how many of its tasks
 * run now. A plugin that ships several capabilities shows their one level
 * when they share it, and Mixed when they do not; the count is theirs
 * together.
 */
import { Badge } from '../../ui/finixt.js';
import { LEVEL_LABEL } from '../../lib/priority.js';
import { useCapabilityPriorities } from './useCapabilityPriorities.js';

export function CardPriority({ capabilityIds }: { capabilityIds: readonly string[] }) {
  const view = useCapabilityPriorities(capabilityIds);
  if (!view || view.rows.length === 0) return null;

  const levels = new Set(view.rows.map((row) => row.effective_level));
  const [only] = levels;
  const onDefault = view.rows.every((row) => row.level === null);
  const label =
    levels.size === 1 && only !== undefined
      ? `${LEVEL_LABEL[only]}${onDefault ? ' · default' : ''}`
      : 'Mixed';
  const running = view.rows.reduce((sum, row) => sum + row.running, 0);
  return (
    <span
      title="Priority, set on the plugin page"
      style={{ marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', gap: 7 }}
    >
      <Badge tone="neutral" shape="square">
        {label}
      </Badge>
      <span
        className="mono"
        style={{ fontSize: 'var(--text-meta-lg)', color: 'var(--text-muted)' }}
      >
        {running} running
      </span>
    </span>
  );
}
